export default __webpack_public_path__ + "static/media/itchio.a420ec46.glb";